module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Design/Anchor-left-down-7b249022bca1a476bf193c7ace1093f9.svg";